import React from "react";
import ReactMarkdown from "react-markdown";

// Optional: for tables, strikethrough, etc.
import remarkGfm from "remark-gfm";

// Clean markdown: remove frontmatter, duplicate title, and repeated footer
const cleanMarkdown = (content, title) => {
  if (!content) return "";

  let cleaned = content.trim();

  // Remove frontmatter
  if (cleaned.startsWith("---")) {
    cleaned = cleaned.replace(/^---[\s\S]*?---/, "").trim();
  }

  // Remove duplicate H1 title
  const titleRegex = new RegExp(`^#\\s+${title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, "i");
  if (titleRegex.test(cleaned)) {
    cleaned = cleaned.replace(/^# .*\n?/, "").trim();
  }

  // Remove repeated trailing FAQs or social footer
  cleaned = cleaned.replace(/(#+\s*FAQs\s*){2,}[\s\S]*$/i, "");

  return cleaned;
};

const MarkdownRenderer = ({ content, imageUrl, title }) => {
  const cleaned = cleanMarkdown(content, title);

  return (
    <div className="prose prose-lg max-w-none dark:prose-invert">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title || "Article image"}
          className="my-4 w-full h-auto rounded-md"
          loading="lazy"
        />
      )}
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          img: ({ node, ...props }) => {
            let src = props.src;
            if (src && src.startsWith("/")) {
              const apiUrl = process.env.REACT_APP_API_URL || "";
              src = `${apiUrl}${src}`;
            }
            return (
              <img
                {...props}
                src={src}
                alt={props.alt || "Article image"}
                className="my-4 w-full h-auto rounded-md"
                loading="lazy"
              />
            );
          },
          a: ({ node, ...props }) => (
            <a
              {...props}
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {props.children}
            </a>
          ),
        }}
      >
        {cleaned}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
